// extracted by mini-css-extract-plugin
export default {"main":"Site_main__0YaYx"};